import { useState, useEffect, useLayoutEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { useHistory } from 'react-router-dom';

import styled from 'styled-components';
import moment from 'moment';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

import FetchModule from '../../Share/Network/FetchModule';

import DurationBox from './DurationBox';
import CalenderModal from './CalenderModal';
import MemberStatusBox from './MemberStatusBox';
import SalesCalendarBox from './SalesCalendarBox';
import SalesPeriodBox from './SalesPeriodBox';
import AttendanceBox from './AttendanceBox';
import MemberEngagementBox from './MemberEngagementBox';
import MembershipPreferenceBox from './MembershipPreferenceBox';
import PointManagementBox from './PointManagementBox';
import RevenueBox from './RevenueBox';

import { ReactComponent as LeftArrowSvg } from '../../../image/LeftArrow.svg';
import { ReactComponent as CalanderSvg } from '../../../image/Calander.svg';

const StatisticsView = forwardRef((props, ref) => {
  const history = useHistory();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const [today, setToday] = useState(moment());
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());

  const [isClickedCalender, setIsClickedCalender] = useState(false);
  const [isReregistLoading, setIsReregistLoading] = useState(false);
  const [isAliveLoading, setIsAliveLoading] = useState(true);
  const [isExpiredLoading, setIsExpiredLoading] = useState(true);
  const [isFrequencyLoading, setIsFrequencyLoading] = useState(true);

  const [partnerGyms, setPartnerGyms] = useState([]);
  const [selectedPartnerGym, setSelectedPartnerGym] = useState(undefined);
  const [selectedPartnerGymIndex, setSelectedPartnerGymIndex] = useState(0);
  const [allMembers, setAllMembers] = useState([]);
  const [frequencyData, setFrequencyData] = useState([]);
  const [bizMessageData, setBizMessageData] = useState([]);
  const [messageData, setMessageData] = useState([]);

  const [durationMembers, setDurationMembers] = useState([]);
  const [durationSum, setDurationSum] = useState(0);
  const [durationAvg, setDurationAvg] = useState(0);

  const [isOpenPartnerGymSales, setIsOpenPartnerGymSales] = useState(false);

  const [attendanceTotal, setAttendanceTotal] = useState([]);
  const [attendanceRanking, setAttendanceRanking] = useState([]);
  const [totalMonthAttendanceCount, setTotalMonthAttendanceCount] = useState(0);

  const [isLoadingAllMember, setIsLoadingAllMember] = useState(true);
  const [isDoughnutLoading, setIsDoughnutLoading] = useState(true);
  const [isSalesLoading, setIsSalesLoading] = useState(true);
  const [isYearLoading, setIsYearLoading] = useState(true);
  const [isRevenueLoading, setIsRevenueLoading] = useState(true);
  const [isDurationLoading, setIsDurationLoading] = useState(true);
  const [isBizMessageLoading, setIsBizMessageLoading] = useState(true);
  const [isMessageLoading, setIsMessageLoading] = useState(true);
  const [isAttendanceLoading, setIsAttendanceLoading] = useState(true);
  const [isEngagementLoading, setIsEngagementLoading] = useState(false);
  const [isMemberStatusLoading, setIsMemberStatusLoading] = useState(true);
  const [isMembershipPreferenceLoading, setIsMembershipPreferenceLoading] = useState(true);
  const [isPointLoading, setIsPointLoading] = useState(false);

  const [salesData, setSalesData] = useState([]);
  const [yearSalesData, setYearSalesData] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [revenue, setRevenue] = useState([]);
  const [durationRevenue, setDurationRevenue] = useState([]);
  const [prevRevenue, setPrevRevenue] = useState([]);
  const [settlements, setSettlements] = useState([]);
  const [settledMerchantUids, setSettledMerchantUids] = useState([]);
  const [settlementCycle, setSettlementCycle] = useState(10);

  const [periodYearSales, setPeriodYearSales] = useState([]);
  const [periodSettlements, setPeriodSettlements] = useState([]);
  const [periodSettledMerchantUids, setPeriodSettledMerchantUids] = useState([]);

  const [totalMaxPrice, setTotalMaxPrice] = useState(0);
  const [engagementReserves, setEngagementReserves] = useState([]);
  const [pointData, setPointData] = useState(null);
  const [isNotReceivedLoading, setIsNotReceivedLoading] = useState(true);
  const [notReceivedData, setNotReceivedData] = useState([]);

  const TopLevelRef = useRef();
  const CalenderButtonRef = useRef();

  useImperativeHandle(ref, () => ({
    setOpacity: (val) => {
      TopLevelRef.current.style.opacity = val;
    },
    setZindex: (val) => {
      TopLevelRef.current.style.zIndex = val;
    }
  }))

  // 파트너 체육관 매출 공개 권한 읽기 — 신규 isOpenSales 우선, 호환 별칭 isOpenPartnerGymSales fallback //
  function getIsOpenSales(partnerGym) {
    if (!partnerGym) return false;
    return partnerGym.isOpenSales != null ? partnerGym.isOpenSales : partnerGym.isOpenPartnerGymSales;
  }

  // 조회 날짜 정리: 화살표 이동 시 1일~말일로 세팅 //
  useLayoutEffect(() => {
    let startDate = today.format('YYYY-MM-') + '01T00:00:00';
    let endDate = moment(startDate).add(1, 'month').subtract(1, 'second');

    setStartDate(moment(startDate));
    setEndDate(endDate);
  }, [today])

  // 파트너 체육관 리스트 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('partner_gym/statistics', 'GET');

        if (responseData.status === 200) {
          const partnerGyms = responseData.data.slice();

          setPartnerGyms(partnerGyms);

          if (partnerGyms.length > 0) {
            setSelectedPartnerGym(partnerGyms[0]);
            setSelectedPartnerGymIndex(0);
            setIsOpenPartnerGymSales(true);
          }
        }
        else if (responseData.status === 401) history.push('/login');
      }
    )();
  }, [])

  // 월단위 정산내역 조회 //
  useEffect(() => {
    if (startDate.format('YYYY-MM-DDTHH:mm:ss') === endDate.format('YYYY-MM-DDTHH:mm:ss')) return;

    let isLastest = true;

    // 정산내역은 월 전체를 조회해야 캘린더에 미래 정산 예정도 표시됨 //
    const settlementEndDate = startDate.clone().add(1, 'month').subtract(1, 'second');

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {

      let requestData = {
        startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
        endDate: settlementEndDate.format('YYYY-MM-DDT23:59:59')
      }

      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('sales/history/settlement', 'POST', requestData);

          if (responseData.status === 200) {
            if (isLastest) {
              let data = responseData.data.settlements.slice();
              let settlementCycle = responseData.data.settlementCycle;
              let settlementCycleUnit = responseData.data.settlementCycleUnit;

              if (settlementCycleUnit === 'month') setSettlementCycle(settlementCycle * 30);
              else if (settlementCycleUnit === 'week') setSettlementCycle(settlementCycle * 7);
              else setSettlementCycle(settlementCycle);

              setSettlements(data);
              setSettledMerchantUids(responseData.data.settledMerchantUids || []);
            }
          }
          else if (responseData.status === 401) history.push('/login');
          else {
            if (isLastest) {
              setSettlementCycle(10);
              setSettlements([]);
              setSettledMerchantUids([]);
            }
          }
        }
      )();
    }
    else {
      if (getIsOpenSales(selectedPartnerGym)) {

        let requestData = {
          storeId: selectedPartnerGym.storeId,
          startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
          endDate: settlementEndDate.format('YYYY-MM-DDT23:59:59')
        }

        const fetchModule = new FetchModule();

        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('sales/history/settlement/partner_gym', 'POST', requestData);

            if (responseData.status === 200) {
              if (isLastest) {
                let data = responseData.data.settlements.slice();
                let settlementCycle = responseData.data.settlementCycle;
                const settlementCycleUnit = responseData.data.settlementCycleUnit;

                if (settlementCycleUnit === 'month') setSettlementCycle(settlementCycle * 30);
                else if (settlementCycleUnit === 'week') setSettlementCycle(settlementCycle * 7);
                else setSettlementCycle(settlementCycle);

                setSettlements(data);
                setSettledMerchantUids(responseData.data.settledMerchantUids || []);
              }
            }
            else if (responseData.status === 401) history.push('/login');
            else {
              if (isLastest) {
                setSettlementCycle(10);
                setSettlements([]);
                setSettledMerchantUids([]);
              }
            }
          }
        )();
      }
      else {
        if (isLastest) {
          setSettlementCycle(10);
          setSettlements([]);
          setSettledMerchantUids([]);
        }
      }
    }

    return () => {
      isLastest = false;
    }
  }, [selectedPartnerGym, startDate, endDate])


  // 이번해 총 매출 분석 + 연단위 구매내역 조회 //
  useEffect(() => {

    let isLastest = true;

    setIsRevenueLoading(true);
    setIsYearLoading(true);

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {
      setIsOpenPartnerGymSales(true);

      let requestData = {
        standardYear: today.format('YYYY') + '-01-01T00:00:00'
      }

      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('sales/revenue/year', 'POST', requestData);

          if (responseData.status === 200) {
            if (isLastest) {
              setMemberships(responseData.data.memberships);
              setRevenue(responseData.data.sales);
              setYearSalesData(responseData.data.sales);
            }
          }
          else if (responseData.status !== 204) {
            if (isLastest) {
              setMemberships([]);
              setRevenue([]);
              setYearSalesData([]);
            }
          }
        }
      )();
    }
    else {
      if (getIsOpenSales(selectedPartnerGym)) {
        let requestData = {
          storeId: selectedPartnerGym.storeId,
          standardYear: today.format('YYYY') + '-01-01T00:00:00'
        }

        const fetchModule = new FetchModule();

        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('sales/revenue/year/partner_gym', 'POST', requestData);

            if (responseData.status === 200) {
              if (isLastest) {
                setMemberships(responseData.data.memberships);
                setRevenue(responseData.data.sales);
                setYearSalesData(responseData.data.sales);
              }
            }
            else if (responseData.status === 201) {
              if (isLastest) {
                setIsOpenPartnerGymSales(false);
                setMemberships([]);
                setRevenue([]);
                setYearSalesData([]);
              }
            }
            else if (responseData.status !== 204) {
              if (isLastest) {
                setMemberships([]);
                setRevenue([]);
                setYearSalesData([]);
              }
            }
          }
        )();
      }
      else {
        if (isLastest) {
          setRevenue([]);
          setYearSalesData([]);
          setIsOpenPartnerGymSales(false);
        }
      }
    }

    return () => {
      isLastest = false;
    }
  }, [selectedPartnerGym, today])


  // LTV 계산용 startDate 연도 기준 매출 조회 //
  useEffect(() => {

    let isLastest = true;

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {
      let requestData = {
        standardYear: startDate.format('YYYY') + '-01-01T00:00:00'
      }

      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('sales/revenue/year', 'POST', requestData);

          if (responseData.status === 200) {
            if (isLastest) setDurationRevenue(responseData.data.sales);
          }
          else if (responseData.status !== 204) {
            if (isLastest) setDurationRevenue([]);
          }
        }
      )();
    }
    else {
      if (getIsOpenSales(selectedPartnerGym)) {
        let requestData = {
          storeId: selectedPartnerGym.storeId,
          standardYear: startDate.format('YYYY') + '-01-01T00:00:00'
        }

        const fetchModule = new FetchModule();

        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('sales/revenue/year/partner_gym', 'POST', requestData);

            if (responseData.status === 200) {
              if (isLastest) setDurationRevenue(responseData.data.sales);
            }
            else if (responseData.status !== 204) {
              if (isLastest) setDurationRevenue([]);
            }
          }
        )();
      }
      else {
        if (isLastest) setDurationRevenue([]);
      }
    }

    return () => {
      isLastest = false;
    }
  }, [selectedPartnerGym, startDate])


  // 지난해 총 매출 분석 데이터 조회 //
  useEffect(() => {
    
    let isLastest = true;

    setIsRevenueLoading(true);

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {
      setIsOpenPartnerGymSales(true);
      
      let requestData = {
        standardYear: today.clone().subtract(1, 'year').format('YYYY') + '-01-01T00:00:00'
      }

      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('sales/revenue/year', 'POST', requestData);

          if (responseData.status === 200) {
            if (isLastest) {
              setPrevRevenue(responseData.data.sales);
              setTotalMaxPrice(responseData.data.totalMaxPrice);
            }
          }
          else if (responseData.status !== 204) {
            if (isLastest) {
              setPrevRevenue([]);
              setTotalMaxPrice(0);
            }
          }
        }
      )();
    }
    else {
      if (getIsOpenSales(selectedPartnerGym)) {
        let requestData = {
          storeId: selectedPartnerGym.storeId,
          standardYear: today.clone().subtract(1, 'year').format('YYYY') + '-01-01T00:00:00'
        }

        const fetchModule = new FetchModule();

        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('sales/revenue/year/partner_gym', 'POST', requestData);

            if (responseData.status === 200) {
              if (isLastest) {
                setPrevRevenue(responseData.data.sales);
                setTotalMaxPrice(responseData.data.totalMaxPrice);
              }
            }
            else if (responseData.status === 201) {
              if (isLastest) {
                setIsOpenPartnerGymSales(false);
                setPrevRevenue([]);
                setTotalMaxPrice(0);
              }
            }
            else if (responseData.status !== 204) {
              if (isLastest) {
                setPrevRevenue([]);
                setTotalMaxPrice(0);
              }
            }
          }
        )();
      }
      else {
        if (isLastest) {
          setPrevRevenue([]);
          setIsOpenPartnerGymSales(false);
          setTotalMaxPrice(0);
        }
      }
    }

    return () => {
      isLastest = false;
    }
  }, [selectedPartnerGym, today])

  // 월단위 구매내역 조회 //
  useEffect(() => {
    if (startDate.format('YYYY-MM-DDTHH:mm:ss') === endDate.format('YYYY-MM-DDTHH:mm:ss')) return;

    let isLastest = true;

    setIsDoughnutLoading(true);
    setIsSalesLoading(true);
    setIsNotReceivedLoading(true);

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {

      let requestData = {
        startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
        endDate: endDate.format('YYYY-MM-DDT23:59:59')
      }

      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('sales/history/month', 'POST', requestData);

          if (responseData.status === 200) {
            let notReceivedList = [];
            let data = responseData.data.slice();

            for (let i = 0; i < data.length; i++) {
              if (data[i].notReceivedPrice > 0 && !data[i].isRefund) {

                let isRefund = false;

                for (let j = 0; j < data.length; j++) {
                  if (data[i].merchantUid === data[j].merchantUid && data[j].isRefund) {
                    isRefund = true;
                    break;
                  }
                }

                if (!isRefund) notReceivedList.push(data[i]);
              }
            }

            if (isLastest) {
              setSalesData(responseData.data);
              setNotReceivedData(notReceivedList);
            }
          }
          else if (responseData.status === 401) history.push('/login');
        }
      )();
    }
    else {
      if (getIsOpenSales(selectedPartnerGym)) {

        let requestData = {
          storeId: selectedPartnerGym.storeId,
          startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
          endDate: endDate.format('YYYY-MM-DDT23:59:59')
        }

        const fetchModule = new FetchModule();

        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('sales/history/month/partner_gym', 'POST', requestData);

            if (responseData.status === 200) {
              const notReceivedList = [];
              let data = responseData.data.slice();

              for (let i = 0; i < data.length; i++) {
                if (data[i].notReceivedPrice > 0 && !data[i].isRefund) {

                  let isRefund = false;

                  for (let j = 0; j < data.length; j++) {
                    if (data[i].merchantUid === data[j].merchantUid && data[j].isRefund) {
                      isRefund = true;
                      break;
                    }
                  }

                  if (!isRefund) notReceivedList.push(data[i]);
                }
              }

              if (isLastest) {
                setSalesData(responseData.data);
                setNotReceivedData(notReceivedList);
              }
            }
            else if (responseData.status === 401) history.push('/login');
            else {
              if (isLastest) {
                setSalesData([]);
                setNotReceivedData([]);
                setIsOpenPartnerGymSales(false);
              }
            }
          }
        )();
      }
      else {
        if (isLastest) {
          setSalesData([]);
          setNotReceivedData([]);
          setIsOpenPartnerGymSales(false);
        }
      }
    }
    
    return () => {
      isLastest = false;
    } 
  }, [selectedPartnerGym, startDate, endDate])

  // 평균 회원 지속일 데이터 불러오기 //
  useEffect(() => {
    if (startDate.format('YYYY-MM-DDTHH:mm:ss') === endDate.format('YYYY-MM-DDTHH:mm:ss')) return;
    
    let isLastest = true;

    setIsDurationLoading(true);

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {

      let requestData = {
        startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
        endDate: endDate.format('YYYY-MM-DDT23:59:59')
      }

      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('membership/duration/avg', 'POST', requestData);

          if (responseData.status === 200) {
            let memberList = responseData.data.slice();
            let durationSum = 0;

            memberList.sort(function (a, b) {
              let x = a.duration;
              let y = b.duration;

              if (x < y) return 1;

              if (x > y) return -1;
            })

            for (let i = 0; i < memberList.length; i++) {
              if (memberList[i].duration < 1) durationSum += 1;
              else durationSum += memberList[i].duration;
            }

            if (isLastest) {
              setDurationAvg(parseFloat((durationSum / memberList.length).toFixed(1)));
              setDurationSum(durationSum);
              setDurationMembers(memberList);
              setIsOpenPartnerGymSales(true);
  
              setTimeout(() => {
                setIsDurationLoading(false);
              }, 1000)
            }
          }
          else if (responseData.status === 401) history.push('/login');
        }
      )();
    }
    else {
      if (getIsOpenSales(selectedPartnerGym)) {
        let requestData = {
          storeId: selectedPartnerGym.storeId,
          endDate: endDate.format('YYYY-MM-DDT23:59:59')
        }

        const fetchModule = new FetchModule();

        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('membership/duration/avg/partner_gym', 'POST', requestData);

            if (responseData.status === 200) {
              const memberList = responseData.data.slice();
              let durationSum = 0;

              memberList.sort(function (a, b) {
                let x = a.duration;
                let y = b.duration;

                if (x < y) return 1;

                if (x > y) return -1;
              })

              for (let i = 0; i < memberList.length; i++) {
                if (memberList[i].duration < 1) durationSum += 1;
                else durationSum += memberList[i].duration;
              }

              if (isLastest) {
                setDurationAvg(parseFloat((durationSum / memberList.length).toFixed(1)));
                setDurationSum(durationSum);
                setDurationMembers(memberList);
                setIsOpenPartnerGymSales(true);
  
                setTimeout(() => {
                  setIsDurationLoading(false);
                }, 1000)
              }
            }
            else if (responseData.status === 401) history.push('/login');
            else {
              if (isLastest) {
                setDurationAvg(0);
                setDurationSum(0);
                setDurationMembers([]);
                setIsOpenPartnerGymSales(false);
  
                setTimeout(() => {
                  setIsDurationLoading(false);
                }, 1000)
              }
            }
          }
        )();
      }
      else {
        if (isLastest) {
          setDurationAvg(0);
          setDurationSum(0);
          setDurationMembers([]);
          setIsOpenPartnerGymSales(false);
  
          setTimeout(() => {
            setIsDurationLoading(false);
          }, 1000)
        }
      }
    }

    return () => {
      isLastest = false;
    }
  }, [selectedPartnerGym, startDate, endDate])

  // 수업 별 수강내역 데이터 불러오기 //
  useEffect(() => {
    if (startDate.format('YYYY-MM-DDTHH:mm:ss') === endDate.format('YYYY-MM-DDTHH:mm:ss')) return;

    let isLastest = true;

    setIsFrequencyLoading(true);

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {
      let requestData = {
        startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
        endDate: endDate.format('YYYY-MM-DDT23:59:59')
      }

      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('reserve/check/frequency', 'POST', requestData);
          
          if (responseData.status === 200) {
            let frequencyData = responseData.data.slice();

            frequencyData.sort(function (a, b) {
              let x = a.classTime;
              let y = b.classTime;

              if (x > y) return 1;

              if (x < y) return -1;
            })

            if (isLastest) {
              setFrequencyData(frequencyData);

              setTimeout(() => {
                setIsFrequencyLoading(false);
              }, 1000)
            }
          }
          else if (responseData.status === 401) history.push('/login');
        }
      )();
    }
    else {
      if (getIsOpenSales(selectedPartnerGym)) {
        let requestData = {
          storeId: selectedPartnerGym.storeId,
          startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
          endDate: endDate.format('YYYY-MM-DDT23:59:59')
        }

        const fetchModule = new FetchModule();

        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('reserve/check/frequency/partner_gym', 'POST', requestData);

            if (responseData.status === 200) {
              let frequencyData = responseData.data.slice();

              frequencyData.sort(function (a, b) {
                const x = a.classTime;
                const y = b.classTime;

                if (x > y) return 1;

                if (x < y) return -1;
              })

              if (isLastest) {
                setFrequencyData(frequencyData);
                setIsOpenPartnerGymSales(true);
  
                setTimeout(() => {
                  setIsFrequencyLoading(false);
                }, 1000)
              }
            }
            else if (responseData.status === 401) history.push('/login');
            else {
              if (isLastest) {
                setFrequencyData([]);
                setIsOpenPartnerGymSales(false);
  
                setTimeout(() => {
                  setIsFrequencyLoading(false);
                }, 1000)
              }
            }
          }
        )();
      }
      else {
        if (isLastest) {
          setFrequencyData([]);
          setIsOpenPartnerGymSales(false);
  
          setTimeout(() => {
            setIsFrequencyLoading(false);
          }, 1000)
        }
      }
    }

    return () => {
      isLastest = false;
    }
  }, [selectedPartnerGym, startDate, endDate])

  // 카카오 알림톡 사용 내역 데이터 불러오기 //
  useEffect(() => {
    if (startDate.format('YYYY-MM-DDTHH:mm:ss') === endDate.format('YYYY-MM-DDTHH:mm:ss')) return;

    let isLastest = true;

    // 카카오 알림톡 로딩 애니메이션 //
    setIsBizMessageLoading(true);

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {
      let requestData = {
        startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
        endDate: endDate.format('YYYY-MM-DDT23:59:59')
      }

      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('biz/usage_history', 'POST', requestData);

          if (responseData.status === 200) {
            if (isLastest) {
              setBizMessageData(responseData.data);

              setTimeout(() => {
                setIsBizMessageLoading(false);
              }, 1000)
            }
          }
          else if (responseData.status === 401) history.push('/login');
        }
      )();
    }
    else {
      if (getIsOpenSales(selectedPartnerGym)) {
        let requestData = {
          storeId: selectedPartnerGym.storeId,
          startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
          endDate: endDate.format('YYYY-MM-DDT23:59:59')
        }

        const fetchModule = new FetchModule();

        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('biz/usage_history/partner_gym', 'POST', requestData);

            if (responseData.status === 200) {
              if (isLastest) {
                setBizMessageData(responseData.data);
                setIsOpenPartnerGymSales(true);
  
                setTimeout(() => {
                  setIsBizMessageLoading(false);
                }, 1000)
              }
            }
            else if (responseData.status === 401) history.push('/login');
            else {
              if (isLastest) {
                setBizMessageData([]);
                setIsOpenPartnerGymSales(false);
  
                setTimeout(() => {
                  setIsBizMessageLoading(false);
                }, 1000)
              }
            }
          }
        )();
      }
      else {
        if (isLastest) {
          setBizMessageData([]);
          setIsOpenPartnerGymSales(false);
  
          setTimeout(() => {
            setIsBizMessageLoading(false);
          }, 1000)
        }
      }
    }

    return () => {
      isLastest = false;
    }
  }, [selectedPartnerGym, startDate, endDate])

   // 메시지 사용 내역 데이터 불러오기 //
   useEffect(() => {
    if (startDate.format('YYYY-MM-DDTHH:mm:ss') === endDate.format('YYYY-MM-DDTHH:mm:ss')) return;

    let isLastest = true;

    // 메시지 로딩 애니메이션 //
    setIsMessageLoading(true);

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {
      let requestData = {
        startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
        endDate: endDate.format('YYYY-MM-DDT23:59:59')
      }

      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('message/usage_history', 'POST', requestData);

          if (responseData.status === 200) {
            if (isLastest) {
              setMessageData(responseData.data);

              setTimeout(() => {
                setIsMessageLoading(false);
              }, 1000)
            }
          }
          else if (responseData.status === 401) history.push('/login');
        }
      )();
    }
    else {
      if (getIsOpenSales(selectedPartnerGym)) {
        let requestData = {
          storeId: selectedPartnerGym.storeId,
          startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
          endDate: endDate.format('YYYY-MM-DDT23:59:59')
        }

        const fetchModule = new FetchModule();

        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('message/usage_history/partner_gym', 'POST', requestData);
            
            if (responseData.status === 200) {
              if (isLastest) {
                setMessageData(responseData.data);
                setIsOpenPartnerGymSales(true);
  
                setTimeout(() => {
                  setIsMessageLoading(false);
                }, 1000)
              }
            }
            else if (responseData.status === 401) history.push('/login');
            else {
              if (isLastest) {
                setMessageData([]);
                setIsOpenPartnerGymSales(false);
  
                setTimeout(() => {
                  setIsMessageLoading(false);
                }, 1000)
              }
            }
          }
        )();
      }
      else {
        if (isLastest) {
          setMessageData([]);
          setIsOpenPartnerGymSales(false);
  
          setTimeout(() => {
            setIsMessageLoading(false);
          }, 1000)
        }
      }
    }

    return () => {
      isLastest = false;
    }
  }, [selectedPartnerGym, startDate, endDate])

  // 회원 데이터 전체 불러오기 //
  useEffect(() => {
    let isLastest = true;

    setIsLoadingAllMember(true);
    setIsReregistLoading(true);
    setIsAliveLoading(true);
    setIsExpiredLoading(true);
    setIsMemberStatusLoading(true);
    setIsMembershipPreferenceLoading(true);

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {
      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.getDataVersion2('member/all/statistics', 'GET');

          if (responseData.status === 200) {
            if (isLastest) {
              setAllMembers(responseData.data);
              setIsLoadingAllMember(false);
            }
          }
          else if (responseData.status === 401) history.push('/login');
          else {
            if (isLastest) {
              setAllMembers([]);
              setIsLoadingAllMember(false);
            }
          }
        }
      )();
    }
    else {
      if (getIsOpenSales(selectedPartnerGym)) {
        const fetchModule = new FetchModule();

        (
          async () => {
            const responseData = await fetchModule.getDataVersion2('member/all/statistics/partner_gym/' + selectedPartnerGym.storeId, 'GET');

            if (responseData.status === 200) {
              if (isLastest) {
                setAllMembers(responseData.data);
                setIsLoadingAllMember(false);
              }
            }
            else if (responseData.status === 401) history.push('/login');
            else {
              if (isLastest) {
                setAllMembers([]);
                setIsLoadingAllMember(false);
              }
            }
          }
        )();
      }
      else {
        if (isLastest) {
          setAllMembers([]);
          setIsLoadingAllMember(false);
        }
      }
    }

    return () => {
      isLastest = false;
    }
  }, [selectedPartnerGym, startDate, endDate])

  // 월 단위 회원 출석 현황 불러오기 //
  useEffect(() => {
    if (startDate.format('YYYY-MM-DDTHH:mm:ss') === endDate.format('YYYY-MM-DDTHH:mm:ss')) return;

    let isLastest = true;

    // 출석률 로딩 애니메이션 //
    setIsAttendanceLoading(true);

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {

      let requestData = {
        startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
        endDate: endDate.format('YYYY-MM-DDT23:59:59')
      }

      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('sales/monthly/attendance', 'POST', requestData);
          
          if (responseData.status === 200) {
            let attendances = JSON.parse(JSON.stringify(responseData.data));
            let totalAttendanceCount = 0;

            attendances.map((data) => {
              data.attendanceCount = data.reserveAttendances.length;

              if (data.attendanceCount > 0) totalAttendanceCount += 1;
            })

            attendances.sort((a, b) => b.attendanceCount - a.attendanceCount);

            if (isLastest) {
              setAttendanceTotal(responseData.data);
              setAttendanceRanking(attendances);
              setTotalMonthAttendanceCount(totalAttendanceCount);
              setIsAttendanceLoading(false);
            }
          }
          else if (responseData.status === 401) history.push('/login');
          else {
            if (isLastest) {
              setAttendanceTotal([]);
              setAttendanceRanking([]);
              setTotalMonthAttendanceCount(0);
              setIsAttendanceLoading(false);
            }
          }
        }
      )();
    }
    else {
      if (getIsOpenSales(selectedPartnerGym)) {

        let requestData = {
          storeId: selectedPartnerGym.storeId,
          startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
          endDate: endDate.format('YYYY-MM-DDT23:59:59')
        }

        const fetchModule = new FetchModule();

        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('sales/monthly/attendance/partner_gym', 'POST', requestData);
           
            if (responseData.status === 200) {
              const attendances = JSON.parse(JSON.stringify(responseData.data));
              let totalAttendanceCount = 0;
  
              attendances.map((data) => {
                data.attendanceCount = data.reserveAttendances.length;
  
                if (data.attendanceCount > 0) totalAttendanceCount += 1;
              })
  
              attendances.sort((a, b) => b.attendanceCount - a.attendanceCount);
  
              if (isLastest) {
                setAttendanceTotal(responseData.data);
                setAttendanceRanking(attendances);
                setTotalMonthAttendanceCount(totalAttendanceCount);
                setIsAttendanceLoading(false);
              }
            }
            else if (responseData.status === 401) history.push('/login');
            else {
              if (isLastest) {
                setAttendanceTotal([]);
                setAttendanceRanking([]);
                setTotalMonthAttendanceCount(0);
                setIsAttendanceLoading(false);
              }
            }
          }
        )();
      }
      else {
        if (isLastest) {
          setAttendanceTotal([]);
          setAttendanceRanking([]);
          setTotalMonthAttendanceCount(0);
          setIsAttendanceLoading(false);
        }
      }
    }
    
    return () => {
      isLastest = false;
    } 
  }, [selectedPartnerGym, startDate, endDate])

  // 월 단위 연령별 이용 분석 및 실시간 출석 현황 불러오기 //
  useEffect(() => {
    if (startDate.format('YYYY-MM-DDTHH:mm:ss') === endDate.format('YYYY-MM-DDTHH:mm:ss')) return;

    let isLastest = true;

    // 연령별 이용 분석 및 실시간 출석 현황 로딩 애니메이션 //
    setIsEngagementLoading(true);

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {

      let requestData = {
        startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
        endDate: endDate.format('YYYY-MM-DDT23:59:59')
      }
      
      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('member/engagement', 'POST', requestData);

          if (responseData.status === 200) {
            if (isLastest) {
              setEngagementReserves(responseData.data);
            }
          }
          else if (responseData.status === 401) history.push('/login');
          else {
            if (isLastest) {
              setEngagementReserves(responseData.data);
            }
          }
        }
      )();
    }
    else {
      if (getIsOpenSales(selectedPartnerGym)) {

        const requestData = {
          storeId: selectedPartnerGym.storeId,
          startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
          endDate: endDate.format('YYYY-MM-DDT23:59:59')
        }

        const fetchModule = new FetchModule();

        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('member/engagement/partner_gym', 'POST', requestData);
           
            if (responseData.status === 200) {
             
              if (isLastest) {
                setEngagementReserves(responseData.data);
              }
            }
            else if (responseData.status === 401) history.push('/login');
            else {
              if (isLastest) {
                setEngagementReserves(responseData.data);
              }
            }
          }
        )();
      }
      else {
        if (isLastest) {

        }
      }
    }
    
    return () => {
      isLastest = false;
    }
  }, [selectedPartnerGym, startDate, endDate])

  // 포인트 관리 집계 데이터 조회 (요약 카드 + 거래내역 + 보유) //
  useEffect(() => {
    let isLastest = true;

    setIsPointLoading(true);

    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) {

      const requestData = {
        startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
        endDate: endDate.format('YYYY-MM-DDT23:59:59')
      }

      const fetchModule = new FetchModule();

      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('point/statistics', 'POST', requestData);

          if (responseData.status === 200) {
            if (isLastest) {
              setPointData(responseData.data);
              setIsPointLoading(false);
            }
          }
          else if (responseData.status === 401) history.push('/login');
          else {
            if (isLastest) {
              setPointData(null);
              setIsPointLoading(false);
            }
          }
        }
      )();
    }
    else {
      if (getIsOpenSales(selectedPartnerGym)) {

        const requestData = {
          storeId: selectedPartnerGym.storeId,
          startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
          endDate: endDate.format('YYYY-MM-DDT23:59:59')
        }

        const fetchModule = new FetchModule();

        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('point/statistics/partner_gym', 'POST', requestData);

            if (responseData.status === 200) {
              if (isLastest) {
                setPointData(responseData.data);
                setIsPointLoading(false);
              }
            }
            else if (responseData.status === 401) history.push('/login');
            else {
              // 201(매출 비공개) 포함 그 외 응답은 빈 데이터 처리 //
              if (isLastest) {
                setPointData(null);
                setIsPointLoading(false);
              }
            }
          }
        )();
      }
      else {
        if (isLastest) {
          setPointData(null);
          setIsPointLoading(false);
        }
      }
    }

    return () => {
      isLastest = false;
    }
  }, [selectedPartnerGym, startDate, endDate])

  // 구간(기간) 매출 데이터 조회 - 연도별 revenue 병합 + 기간 정산내역 //
  useEffect(() => {
    if (isMonthMode()) return;
    if (startDate.format('YYYY-MM-DDTHH:mm:ss') === endDate.format('YYYY-MM-DDTHH:mm:ss')) return;

    let isLastest = true;

    const isMyStore = selectedPartnerGym === undefined || selectedPartnerGym.isMyStore;
    const isOpen = isMyStore || getIsOpenSales(selectedPartnerGym);

    if (!isOpen) {
      setPeriodYearSales([]);
      setPeriodSettlements([]);
      setPeriodSettledMerchantUids([]);
      setIsYearLoading(false);
      return;
    }

    setIsYearLoading(true);

    let years = [];

    for (let year = startDate.year(); year <= endDate.year(); year++) years.push(year);

    const revenueEndpoint = isMyStore ? 'sales/revenue/year' : 'sales/revenue/year/partner_gym';
    const settlementEndpoint = isMyStore ? 'sales/history/settlement' : 'sales/history/settlement/partner_gym';

    const fetchModule = new FetchModule();
    (
      async () => {
        // 연도별 매출 병합 //
        let mergedSales = [];

        for (const year of years) {
          let requestData = { standardYear: year + '-01-01T00:00:00' };

          if (!isMyStore) requestData.storeId = selectedPartnerGym.storeId;

          const responseData = await fetchModule.postDataVersion2(revenueEndpoint, 'POST', requestData);

          if (responseData.status === 200) mergedSales = mergedSales.concat(responseData.data.sales);
          else if (responseData.status === 401) {
            history.push('/login');
            return;
          }
        }

        // 기간 전체 정산내역 //
        let settlementRequest = {
          startDate: startDate.format('YYYY-MM-DDTHH:mm:ss'),
          endDate: endDate.format('YYYY-MM-DDT23:59:59')
        }

        if (!isMyStore) settlementRequest.storeId = selectedPartnerGym.storeId;

        const settlementResponse = await fetchModule.postDataVersion2(settlementEndpoint, 'POST', settlementRequest);

        if (!isLastest) return;

        setPeriodYearSales(mergedSales);

        if (settlementResponse.status === 200) {
          let cycle = settlementResponse.data.settlementCycle;
          const cycleUnit = settlementResponse.data.settlementCycleUnit;

          if (cycleUnit === 'month') setSettlementCycle(cycle * 30);
          else if (cycleUnit === 'week') setSettlementCycle(cycle * 7);
          else setSettlementCycle(cycle);

          setPeriodSettlements(settlementResponse.data.settlements.slice());
          setPeriodSettledMerchantUids(settlementResponse.data.settledMerchantUids || []);
        }
        else if (settlementResponse.status === 401) history.push('/login');
        else {
          setSettlementCycle(10);
          setPeriodSettlements([]);
          setPeriodSettledMerchantUids([]);
        }
      }
    )();

    return () => {
      isLastest = false;
    }
  }, [selectedPartnerGym, startDate, endDate])

  function onClickNextMonth() {
    if (!isMonthMode()) return;

    if (today.clone().add(1, 'month').format('YYYY.MM') <= moment().format('YYYY.MM')) {
      setIsDoughnutLoading(true);
      setToday(today.clone().add(1, 'month'));
    }
  }


  // 선택된 기간이 현재 월 전체와 일치하는지 여부 //
  function isMonthMode() {
    const start = moment(today.format('YYYY-MM-') + '01T00:00:00');
    const end = moment(start).add(1, 'month').subtract(1, 'second');

    return startDate.format('YYYY-MM-DDTHH:mm:ss') === start.format('YYYY-MM-DDTHH:mm:ss')
      && endDate.format('YYYY-MM-DDTHH:mm:ss') === end.format('YYYY-MM-DDTHH:mm:ss');
  }

  // 통계 날짜 텍스트 정리 //
  function calcDateText() {
    if (isMonthMode()) return today.clone().format(t('statistics.dateFormatMonth'));

    // 시작이 시작월 1일이고 끝이 종료월 말일이면 월 단위로 표출 //
    const isFullMonthRange = startDate.format('YYYY-MM-DDTHH:mm:ss') === startDate.clone().startOf('month').format('YYYY-MM-DDTHH:mm:ss')
      && endDate.format('YYYY-MM-DDTHH:mm:ss') === endDate.clone().endOf('month').format('YYYY-MM-DDTHH:mm:ss');
    if (isFullMonthRange) {
      const monthFormat = t('statistics.dateFormatMonthShort');
      return startDate.format(monthFormat) + ' - ' + endDate.format(monthFormat);
    }

    // 시작/종료 연도가 다르면 종료일에도 연도 표시 //
    const endFormat = startDate.year() === endDate.year() ? t('statistics.dateFormatShortRange') : t('statistics.dateFormatRange');

    return startDate.format(t('statistics.dateFormatRange')) + ' - ' + endDate.format(endFormat);
  }

  // 파트너 체육관 이름 표출 //
  function decideSelectedPartnerGymName() {
    if (selectedPartnerGym === undefined) return '';
    else return selectedPartnerGym.storeName;
  }

  // 파트너 체육관 이전 클릭시 //
  function onClickPrevSelectedPartnerGym() {
    if (selectedPartnerGymIndex - 1 >= 0) {
      setSelectedPartnerGym(partnerGyms[selectedPartnerGymIndex - 1]);
      setSelectedPartnerGymIndex(selectedPartnerGymIndex - 1);

      if (partnerGyms[selectedPartnerGymIndex - 1].isMyStore) setIsOpenPartnerGymSales(true);
      else setIsOpenPartnerGymSales(getIsOpenSales(partnerGyms[selectedPartnerGymIndex - 1]));
    }
  }

  // 파트너 체육관 다음 클릭시 //
  function onClickNextSelectedPartnerGym() {
    if (selectedPartnerGymIndex + 1 < partnerGyms.length) {
      setSelectedPartnerGym(partnerGyms[selectedPartnerGymIndex + 1]);
      setSelectedPartnerGymIndex(selectedPartnerGymIndex + 1);

      if (partnerGyms[selectedPartnerGymIndex + 1].isMyStore) setIsOpenPartnerGymSales(true);
      else setIsOpenPartnerGymSales(getIsOpenSales(partnerGyms[selectedPartnerGymIndex + 1]));
    }
  }

  // 파트너 체육관 매출 오픈 여부 확인 //
  function decideOpenSalesForPartnerGyms() {
    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) return true;
    else return getIsOpenSales(selectedPartnerGym);
  }

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      {
        isClickedCalender &&
        <CalenderModal
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          onClickExitButton={() => setIsClickedCalender(false)} />
      }
      <TotalTitleWrapper>
        <TitleWrapper>
          <Title>{t('statistics.title')}</Title>
          <Explanation>{t('statistics.desc')}</Explanation>
        </TitleWrapper>
        {
          partnerGyms.length > 1 &&
          <PartnerGymSelectBox>
            <StyledLeftArrow $isDisabled={selectedPartnerGymIndex === 0} onClick={onClickPrevSelectedPartnerGym} />
            <StoreNameTextWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.subText} cursor='default'>{decideSelectedPartnerGymName()}</Text>
            </StoreNameTextWrapper>
            <StyledRightArrow $isDisabled={selectedPartnerGymIndex === partnerGyms.length - 1} onClick={onClickNextSelectedPartnerGym} />
          </PartnerGymSelectBox>
        }
      </TotalTitleWrapper>
      <DateTotalWrapper>
        <DateButton>
          <StyledLeftArrow $isDisabled={!isMonthMode()} onClick={() => isMonthMode() && setToday(today.clone().subtract(1, 'month'))} />
          <DateText>{calcDateText()}</DateText>
          <StyledRightArrow $isDisabled={!isMonthMode() || today.clone().format('YYYY.MM') === moment().format('YYYY.MM')} onClick={onClickNextMonth} />
        </DateButton>
        <CalenderButton ref={CalenderButtonRef} onClick={() => setIsClickedCalender(true)}>
          <StyledCalander />
        </CalenderButton>
      </DateTotalWrapper>

      {
        isMonthMode() ?
          <SalesCalendarBox
            standardDate={today}
            settlementCycle={settlementCycle}
            settlements={settlements}
            settledMerchantUids={settledMerchantUids}
            yearSales={yearSalesData}
            isOpenPartnerGymSales={decideOpenSalesForPartnerGyms()}
            setIsYearLoading={setIsYearLoading} />
          :
          <SalesPeriodBox
            startDate={startDate}
            endDate={endDate}
            settlementCycle={settlementCycle}
            settlements={periodSettlements}
            settledMerchantUids={periodSettledMerchantUids}
            yearSales={periodYearSales}
            isOpenPartnerGymSales={decideOpenSalesForPartnerGyms()}
            setIsYearLoading={setIsYearLoading} />
      }

      <SectionDivisionLine />

      <RevenueBox
        today={today}
        calcDateText={calcDateText}

        isMonthMode={isMonthMode()}
        startDate={startDate}
        endDate={endDate}
        periodYearSales={periodYearSales}

        totalMaxPrice={totalMaxPrice}
        revenue={revenue}
        prevRevenue={prevRevenue}

        selectedPartnerGym={selectedPartnerGym}
        isOpenPartnerGymSales={decideOpenSalesForPartnerGyms()}

        isRevenueLoading={isRevenueLoading}
        setIsRevenueLoading={setIsRevenueLoading}

        salesData={salesData}
        isSalesLoading={isSalesLoading}
        setIsSalesLoading={setIsSalesLoading} />

      <SectionDivisionLine />

      <AttendanceBox
        today={today}
        isMonthMode={isMonthMode()}
        startDate={startDate}
        endDate={endDate}
        calcDateText={calcDateText}

        attendanceTotal={attendanceTotal}
        attendanceRanking={attendanceRanking}
        totalMonthAttendanceCount={totalMonthAttendanceCount}

        allMembers={allMembers}
        isLoadingAllMember={isLoadingAllMember}

        selectedPartnerGym={selectedPartnerGym}
        isOpenPartnerGymSales={decideOpenSalesForPartnerGyms()}
        isAttendanceLoading={isAttendanceLoading}
        setIsAttendanceLoading={setIsAttendanceLoading}

        frequencyData={frequencyData}
        isFrequencyLoading={isFrequencyLoading}/>

      <SectionDivisionLine />

      <MemberStatusBox
        allMembers={allMembers}
        salesData={salesData}
        startDate={startDate}
        endDate={endDate}
        isMonthMode={isMonthMode()}
        calcDateText={calcDateText}
        selectedPartnerGym={selectedPartnerGym}
        isOpenPartnerGymSales={decideOpenSalesForPartnerGyms()}
        isLoadingAllMember={isLoadingAllMember}
        isLoading={isMemberStatusLoading}
        setIsLoading={setIsMemberStatusLoading} />

      <SectionDivisionLine />

      <DurationBox
        calcDateText={calcDateText}
        startDate={startDate}
        endDate={endDate}
        revenue={durationRevenue}
        durationAvg={durationAvg}
        durationMembers={durationMembers}
        allMembers={allMembers}
        isOpenPartnerGymSales={decideOpenSalesForPartnerGyms()}
        isDurationLoading={isDurationLoading} />

      <SectionDivisionLine />

      <MembershipPreferenceBox
        calcDateText={calcDateText}
        startDate={startDate}
        endDate={endDate}
        allMembers={allMembers}
        salesData={salesData}
        isLoadingAllMember={isLoadingAllMember}
        isOpenPartnerGymSales={decideOpenSalesForPartnerGyms()}
        isMembershipPreferenceLoading={isMembershipPreferenceLoading}
        setIsMembershipPreferenceLoading={setIsMembershipPreferenceLoading} />

      <SectionDivisionLine />

      <MemberEngagementBox
        calcDateText={calcDateText}
        startDate={startDate}
        endDate={endDate}
        engagementReserves={engagementReserves}
        allMembers={allMembers}
        isOpenPartnerGymSales={decideOpenSalesForPartnerGyms()}
        isEngagementLoading={isEngagementLoading}
        setIsEngagementLoading={setIsEngagementLoading} />

      <SectionDivisionLine />

      <PointManagementBox
        calcDateText={calcDateText}
        pointData={pointData}
        selectedPartnerGym={selectedPartnerGym}
        isOpenPartnerGymSales={decideOpenSalesForPartnerGyms()}
        isPointLoading={isPointLoading} />

    </TopLevelWrapper>
  )
})

export default StatisticsView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  opacity: 1;
  
  transition: all 0.3s ease-in-out;
`;

const TotalTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  gap: 4px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const PartnerGymSelectBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 12px 0px 12px;

  width: 227px;
  height: 38px;

  border: 1px solid ${props => props.theme.subBackground};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
`;

const DateTotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 8px;

  margin-top: 38px;
`;

const DateButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 12px 0px 12px;

  width: 261px;
  height: 38px;


  border: 1px solid ${props => props.theme.buttonStroke};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
`;

const DateText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const CalenderButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 38px;
  height: 38px;

  border: 1px solid ${props => props.theme.buttonStroke};
  border-radius: 12px;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    border: 1px solid ${props => props.theme.text};

    svg path {
      fill: ${props => props.theme.text};
    }
  }
`;

const StyledLeftArrow = styled(LeftArrowSvg)`
  flex-shrink: 0;
  width: 8px;
  height: 13px;

  & path {
    fill: ${props => props.$isDisabled ? props.theme.line : props.theme.subText};
  }

  &:hover {
    cursor: ${props => props.$isDisabled ? 'default' : 'pointer'};
  }
`;

const StyledRightArrow = styled(LeftArrowSvg)`
  flex-shrink: 0;
  width: 8px;
  height: 13px;
  transform: scaleX(-1);

  & path {
    fill: ${props => props.$isDisabled ? props.theme.line : props.theme.subText};
  }

  &:hover {
    cursor: ${props => props.$isDisabled ? 'default' : 'pointer'};
  }
`;

const StyledCalander = styled(CalanderSvg)`
  flex-shrink: 0;
  width: 18px;
  height: 18px;

  & path {
    fill: ${props => props.theme.line};
    transition: fill 0.3s ease-in-out;
  }
`;

const StoreNameTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 80%;
  height: 24px;

  overflow: hidden;
`;

const SectionDivisionLine = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;
  align-self: center;

  width: calc(100% - 120px);
  height: 1px;

  border-radius: 200px;
  background-color: ${props => props.theme.line};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.size}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

